















































































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';

import waitingOrderOption from '@/table/delivery/waitingDelivery';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useAuth from '@/useAuth';
import useDelivery from '@/useDelivery';
import useVehicle from '@/useVehicle';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonChip from '@/components/CommonChip.vue';
import CommonDeliveryStatusSelect from '@/components/Delivery/CommonDeliveryStatusSelect.vue';
import CommonModalWithReasonSelector from '@/components/DeliveryNote/CommonModalWithReasonSelector.vue';

import tempDeliveries from '@/gql/delivery/tempDelivery/tempDeliveries.gql';
import deleteDelivery from '@/gql/delivery/deleteDelivery.gql';
import countDelivery from '@/gql/delivery/countDelivery.gql';
import batchUpdateTempDeliveryStatus from '@/gql/delivery/tempDelivery/batchUpdateTempDeliveryStatus.gql';

const WaitingOrder = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonDeliveryStatusSelect,
    CommonChip,
    CommonModalWithReasonSelector,
  },
  setup() {
    const { me } = useAuth();
    const { translateDistanceType, distanceTypeToChipClass } = useDeliveryAreaCode();
    const {
      type, typeDisplay, tempDeliveryStatus, tempDeliveryStatusDisplay,
    } = useDelivery();
    const {
      typeId: vehicleTypeList, typeDisplay: vehicleTypeDisplay,
    } = useVehicle();

    const filter = reactive({
      status: '',
      text: '',
      orderDate: {
        from: undefined,
        to: undefined,
      },
      filterType: undefined,
      filterByStatus: 'WAITING_TO_CONFIRM',
      filterVehicleType: undefined,
    });
    function clickDateHandler(date: any) {
      if (filter.orderDate.from === useFormat.date(date).computerShortDate()) {
        filter.orderDate = {
          from: undefined,
          to: undefined,
        };
      } else {
        filter.orderDate = {
          from: useFormat.date(date).computerShortDate(),
          to: useFormat.date(date).computerShortDate(),
        };
      }
    }
    const tempDeliveriesVariable = computed(() => {
      const vars: {[key: string]: any} = {
        searchCustomerName: undefined,
        filterByStatus: filter.filterByStatus ? filter.filterByStatus : undefined,
        filterByType: filter.filterType ? filter.filterType : undefined,
        filterByVehicleType: filter.filterVehicleType ? filter.filterVehicleType : undefined,
        filterOrderDateBetween: undefined,
      };
      if (filter.text) {
        vars.searchCustomerName = `%${filter.text}%`;
      }
      if (filter.orderDate.from) {
        vars.filterOrderDateBetween = filter.orderDate;
      }
      return vars;
    });
    const getOrdersResult = (data: any) => data.tempDeliveries;

    // Use with select box
    const selectedItemId: Ref<number[]> = ref([]);
    function selectItem(id: number | string) {
      const hitIndex = selectedItemId.value.indexOf(parseInt(id as string, 10));
      if (selectedItemId.value.indexOf(parseInt(id as string, 10)) > -1) selectedItemId.value.splice(hitIndex, 1);
      else selectedItemId.value.push(parseInt(id as string, 10));
    }

    // Not accept reason
    const notAcceptReasons = reactive([
      { label: 'พื้นที่ไม่เพียงพอ', active: false },
      { label: 'รถไม่เพียงพอ', active: false },
      { label: 'รถเสีย', active: false },
      { label: 'ศูนย์กระจายสินค้า ปิดทำการ', active: false },
      { label: 'สินค้าผิดคุณภาพ', active: false },
      { label: '', active: false },
    ]);

    // ==============================================
    // ===== Use to delete Delivery from system =====
    // ==============================================
    const refetchQueriesList = [
      'tempDeliveries', 'countDelivery', 'countDeliveryStatus',
    ];
    const deleteDeliveryModal = ref(null);
    const deleteDeliveryMutation = useMutation(deleteDelivery, {
      refetchQueries: refetchQueriesList,
    });
    function deleteDeliveryAction(deliveryId: number) {
      deleteDeliveryMutation.mutate({
        id: deliveryId,
      });
    }

    const notAcceptReason = ref('');
    const notAcceptDeliveryModal = ref(null);

    const batchStatus = ref('REJECTED');
    const batchUpdateDeliveryStatusMutation = useMutation(batchUpdateTempDeliveryStatus, () => ({
      variables: {
        ids: selectedItemId.value,
        status: batchStatus.value,
        rejectReason: notAcceptReason.value,
      },
      refetchQueries: refetchQueriesList,
    }));
    const batchUpdateDeliveriesStatusAction = (status: string) => {
      batchStatus.value = status;
      batchUpdateDeliveryStatusMutation.mutate();
    };
    function confirmNotAccept(val: { reason: string; index: number }) {
      const { reason } = val;
      notAcceptReason.value = reason;
      batchUpdateDeliveriesStatusAction('REJECTED');
      (notAcceptDeliveryModal.value as any).close();
    }
    batchUpdateDeliveryStatusMutation.onDone(() => {
      selectedItemId.value = [];
    });

    // count delivery to display on top panel
    const totalPendingOrder = ref(0);
    const { result: getCountDeliveryResult, loading: countDeliveryLoading } = useQuery(tempDeliveries, () => ({
      filterByStatus: filter.filterByStatus ? filter.filterByStatus : undefined,
      filterByType: filter.filterType ? filter.filterType : undefined,
      filterByVehicleType: filter.filterVehicleType ? filter.filterVehicleType : undefined,
    }), () => ({ fetchPolicy: 'cache-and-network' }));
    const countDeliveryResult = computed(() => getCountDeliveryResult.value?.tempDeliveries.paginatorInfo.total || 0);
    // const { result: getCountDeliveryResult, loading: countDeliveryLoading } = useQuery(countDelivery, () => ({
    //   filterOrderDateBetween: filter.orderDate.from ? filter.orderDate : undefined,
    // }), () => ({
    //   fetchPolicy: 'cache-and-network',
    // }));
    // const countDeliveryResult = useResult(getCountDeliveryResult, [
    //   { status: 'PENDING_ORDER_CONFIRMATION', count: 0 },
    // ], (data) => data.countDelivery);
    // watch(() => countDeliveryResult.value, (newVal, oldVal) => {
    //   if (!countDeliveryLoading.value && newVal !== oldVal) {
    //     totalPendingOrder.value = countDeliveryResult.value.find((countObj: any) => countObj.status === 'PENDING_ORDER_CONFIRMATION')?.count || 0;
    //   }
    // });

    return {
      me,
      type,
      typeDisplay,
      translateDistanceType,
      distanceTypeToChipClass,
      vehicleTypeList,
      vehicleTypeDisplay,

      filter,
      clickDateHandler,
      waitingOrderOption,
      tempDeliveries,
      tempDeliveryStatus,
      tempDeliveryStatusDisplay,
      tempDeliveriesVariable,
      getOrdersResult,

      selectItem,
      selectedItemId,

      deleteDeliveryModal,
      deleteDeliveryMutation,
      deleteDeliveryAction,

      totalPendingOrder,
      countDeliveryResult,

      // use with not accept shipment
      notAcceptReasons,
      notAcceptDeliveryModal,
      confirmNotAccept,

      batchUpdateDeliveriesStatusAction,
    };
  },
});

export default WaitingOrder;
